import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import * as dayjs from 'dayjs';

import { StorageService } from 'src/app/services/storage.service';
import { ToastService } from 'src/app/services/toast.service';
import { UserService } from 'src/app/services/user.service';
import { RoutineService } from 'src/app/services/routine.service';

import { Plan } from 'src/app/interfaces/plan';
import { User } from 'src/app/interfaces/user';
import { Router } from '@angular/router';
import { StateService } from 'src/app/services/state.service';

@Component({
  selector: 'app-user-config-modal',
  templateUrl: './user-config-modal.component.html',
  styleUrls: ['./user-config-modal.component.scss'],
})
export class UserConfigModalComponent implements OnInit {
  @Input() user: User | undefined;
  staffUser!: User;

  userRole: UntypedFormControl = new UntypedFormControl('');
  constructor(
    private router: Router,
    private userService: UserService,
    private toastService: ToastService,
    private storageService: StorageService,
    private routineService: RoutineService,
    private stateService: StateService
  ) {}

  ngOnInit(): void {
    this.staffUser = this.storageService.get('staffUser');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['user']) {
      if (this.user && this.user.planHistory) this.getUserPlan();

      if (this.user) {
        this.userRole.setValue(this.user.role);
      }
    }
  }

  getUserPlan() {
    this.userService.getPlans().subscribe({
      next: (plans: Plan[]) => {
        this.user?.planHistory.forEach((plan: Plan) => {
          const userPlan: Plan = plans.filter((p: Plan) => {
            return p.id == plan.planId;
          })[0];

          plan.name = userPlan.name;

          let startDate = dayjs(plan.startAt).utc();

          let newDate = `${startDate
            .get('date')
            .toString()
            .padStart(2, '0')}/${(startDate.get('month') + 1)
            .toString()
            .padStart(2, '0')}/${startDate.get('year')}`;

          if (newDate.charAt(newDate.length - 1) == '0') {
            newDate = 'No definido';
          }

          plan.planStartAtParsed = newDate;

          if (plan.finishAt.Valid) {
            let finishDate = dayjs(plan.finishAt.Time).utc();

            let newDate = `${finishDate
              .get('date')
              .toString()
              .padStart(2, '0')}/${(finishDate.get('month') + 1)
              .toString()
              .padStart(2, '0')}/${finishDate.get('year')}`;

            plan.planFinishAtParsed = newDate;
          } else {
            plan.planFinishAtParsed = 'No finalizado';
          }
        });
      },
    });
  }

  finishPlan(planId: number) {
    this.userService.finishPlan(planId).subscribe({
      next: () => {
        this.toastService.success('Plan finalizado con éxito.');

        const plan = this.user?.planHistory.filter(
          (plan: Plan) => plan.id == planId
        )[0];

        plan!.status = 'FINISHED';
      },
      error: () => {
        this.toastService.alert('No se finalizo el plan con éxito.');
      },
    });
  }

  changeRol() {
    this.userService
      .changeRole({ userId: this.user?.id!, role: this.userRole.value })
      .subscribe({
        next: () => {
          this.toastService.success('Rol Cambiado con éxito.');
        },
        error: () => {
          this.toastService.alert('No se pudo cambiar el rol con éxito.');
        },
      });
  }

  obtainUserFormData() {
    this.user!.sendingEmail = true;
    this.routineService.getProgretion(this.user!.id, 0).subscribe({
      next: () => {
        this.user!.sendingEmail = false;
        this.toastService.success(
          'información de el usuario enviada a tu email! 📧'
        );
      },
      error: () => {
        this.user!.sendingEmail = false;
        this.toastService.alert(
          'No pudimos enviar la información a tu email! Si el error persiste contactate con el soporte.'
        );
      },
    });
  }

  showUserForms() {
    if (this.stateService.openModal) {
      this.stateService.openModal.dispose();
    }

    document.body.classList.remove('modal-open');
    document.body.style.overflow = 'auto';
    this.router.navigate([`/user-forms/${this.user?.id}`]);
  }
}
